export default __webpack_public_path__ + "static/media/bookmark.3b9cc935.svg";